import React, { useState } from "react";

import { normalizar } from "../../../../components/buscadorBarra/buscadorBarra";
import { AulaOpcion, Conflicto, fechaCorta } from "./horarioFormApi";

/** «Aula 4 ocupada Sábados 11:00 am - 3:00 pm por Barbería Módulo 1 (José Pavón, 14 alumnas) hasta 13/03/2027». */
export const textoConflicto = (c: Conflicto): string => {
	const base = (c.curso || "").replace(/^(diplomado|curso|taller)\s+(de|en|del)\s+/i, "");
	const grupo = c.modulo && base && normalizar(c.modulo).includes(normalizar(base)) ? c.modulo : [base, c.modulo].filter(Boolean).join(" ");
	const alumnas = (c.alumnas === 1 ? "1 alumna" : (c.alumnas || 0) + " alumnas");
	const hasta = c.fin ? " hasta " + fechaCorta(c.fin) : "";
	if (c.tipo === "maestra") {
		return (c.maestra || "La maestra") + " ya da " + grupo + " " + (c.hora || "") + (c.aula ? " en " + c.aula : "") + " (" + alumnas + ")" + hasta + ".";
	}
	return (c.aula || "El aula") + " ocupada " + (c.hora || "") + " por " + grupo + " (" + [c.maestra, alumnas].filter(Boolean).join(", ") + ")" + hasta + ".";
};

interface Props {
	conflictos: Conflicto[];
	esSuper: boolean;
	forzar: string | null;
	onForzar: (motivo: string | null) => void;
	onLibres: () => void;
	libres: AulaOpcion[] | null;
	cargandoLibres: boolean;
	errorLibres: string | null;
	onElegirAula: (a: AulaOpcion) => void;
	sinEdicion?: boolean;
}

/** Aviso de oro cuando hay choque: dice con quién, ofrece aulas libres y (solo Super Admin) guardar con motivo. */
const AvisoChoque: React.FC<Props> = ({ conflictos, esSuper, forzar, onForzar, onLibres, libres, cargandoLibres, errorLibres, onElegirAula, sinEdicion }) => {
	const [pidiendo, setPidiendo] = useState(false);
	const [motivo, setMotivo] = useState("");
	const hayAula = conflictos.some((c) => c.tipo === "aula");
	const letras = motivo.replace(/\s+/g, "").length; // igual que el servidor: sin contar espacios

	if (conflictos.length < 1) return null;
	return (
		<div className="hf-aviso" role="alert">
			<b>{hayAula ? "El Aula Está Ocupada" : "La Maestra Ya Tiene Clase"}</b>
			{conflictos.map((c, i) => <p key={i}>{textoConflicto(c)}</p>)}
			{forzar ? (
				<p><b style={{ display: "inline" }}>Se guardará con el choque.</b> Motivo: {forzar}</p>
			) : null}
			<div className="hf-acciones">
				{hayAula && !sinEdicion ? (
					<button type="button" className="hf-boton" onClick={onLibres} disabled={cargandoLibres}>{cargandoLibres ? "Buscando…" : "Aulas Libres a Esa Hora"}</button>
				) : null}
				{esSuper && !forzar && !pidiendo ? (
					<button type="button" className="hf-boton" onClick={() => setPidiendo(true)}>Guardar de Todas Formas…</button>
				) : null}
				{esSuper && forzar ? (
					<button type="button" className="hf-boton" onClick={() => { onForzar(null); setPidiendo(false); setMotivo(""); }}>Quitar Motivo</button>
				) : null}
			</div>
			{errorLibres ? <p style={{ marginTop: 8 }}>{errorLibres}</p> : null}
			{libres ? (
				libres.length > 0 ? (
					<div className="hf-pastillas">
						{libres.map((a) => <button type="button" key={a.id} className="hf-pastilla" onClick={() => onElegirAula(a)}>{a.name + (a.edificio ? " (" + a.edificio + ")" : "")}</button>)}
					</div>
				) : <p style={{ marginTop: 8 }}>No hay aulas libres a esa hora.</p>
			) : null}
			{esSuper && pidiendo && !forzar ? (
				<div className="hf-motivo">
					<label htmlFor="hf-motivo-txt" style={{ position: "static", fontSize: 13.5, fontWeight: 600, margin: 0 }}>Motivo (mínimo 10 letras)</label>
					<textarea id="hf-motivo-txt" className="hf-in" value={motivo} maxLength={250} onChange={(e) => setMotivo(e.target.value)} />
					<div className="hf-acciones" style={{ marginTop: 0 }}>
						<button type="button" className="hf-boton" disabled={letras < 10} onClick={() => { onForzar(motivo.trim()); setPidiendo(false); }}>Aceptar Motivo</button>
						<button type="button" className="hf-boton" onClick={() => { setPidiendo(false); setMotivo(""); }}>Cancelar</button>
						{letras < 10 ? <span style={{ alignSelf: "center", fontSize: 13.5 }}>{letras} de 10 letras</span> : null}
					</div>
				</div>
			) : null}
		</div>
	);
};

export default AvisoChoque;
